import React, {FC} from "react";
import MaterialSelector from "./MaterialSelector";
import {Controller} from "react-hook-form";

import {MenuItem} from "@material-ui/core";

interface FormMaterialSelectorProps {
    control: any;
    name: string;
    label: string;
    disabled?: boolean;
    defaultValue?: any;
    className?: string;
    children: React.ReactElement<typeof MenuItem>[] | null;
}

export const FormMaterialSelector: FC<FormMaterialSelectorProps> = ({ className, name, disabled, label, control, defaultValue, children}) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, ...rest }) => {
                return (
                    <MaterialSelector
                        key={field.value}
                        disabled={disabled}
                        defaultValue={defaultValue}
                        className={className}
                        value={field.value}
                        name={field.name}
                        label={label}
                        onChange={field.onChange}
                        errorMessage={rest.formState.errors[name]?.message as string || ''}
                    >
                        {children}
                    </MaterialSelector>
                )
            }}
        />
    );
};